import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { SPECIAL_FORM_LINK } from 'src/app/constant/constant';
import { ZoomService } from 'src/app/services/zoom.service';

import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { url_testimonials_source } from 'src/app/models/feedback';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
    selector: 'app-home-novspecial',
    templateUrl: './home-novspecial.component.html',
    styleUrls: [
        './home-novspecial.component.css',
        './../../../../assets/css/custom-egd-1.css'
    ]
})
@TraceClassDecorator()
export class HomeNovspecialComponent implements OnInit {
    @Input('is_doctor')
    is_doctor: boolean = false;
    url_link: string = '';
    slug: string = "";
    feedback_url: string =
        'feedback/' + url_testimonials_source['free_counseling'];

    weekdays: string[][] = [
        ['6:00AM', '10:30AM'],
        ['5:30PM', '8:30PM']
    ];
    weekends: string[][] = [
        ['6:00AM', '10:30AM'],
        ['5:30PM', '9:30PM']
    ];
    form_link: string = SPECIAL_FORM_LINK;
    response_success = null;
    feedback_type = url_testimonials_source;
    constructor(
        public zoomService: ZoomService,
        private router: Router,
        private utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        await this.getSpecialLinkandTimings();
    }
    async getSpecialLinkandTimings() {
        await this.zoomService
            .GetSpecialZoomLink()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.response_success = result.success;
                    //Patient Link
                    if (this.is_doctor != null && !this.is_doctor) {
                        this.url_link = result.data.link;
                        //weekdays is at 0
                        this.weekdays = result.data.timings[0];
                        //weekdays is at 1
                        this.weekends = result.data.timings[1];
                    }
                }
            });
    }
    openZoomLink() {
        window.open(this.url_link, '_blank');
    }

    open_form() {
        window.open(this.form_link, '_blank');
    }
    open_membership() {
        this.router.navigate(['/' + this.slug + '/patient/members/add']);
    }
    getBoolean(value: any): boolean {
        return Boolean(value);
    }

    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(
            base_url_name,
            link,
            target
        );
    }
}
